import { useReleaseFlag, useReleaseFlagsLoading } from 'hooks/useReleaseFlags';
import { UsePlacesProps, UsePlacesReturn } from './usePlaces.types';
import { useApiPlaces } from './useApiPlaces';
import { useLegacyPlaces } from './useLegacyPlaces';

export const usePlaces = (props: UsePlacesProps = {}): UsePlacesReturn => {
  const serverSourceOfTruth = useReleaseFlag('places_server_source_of_truth');
  const flagsLoading = useReleaseFlagsLoading();

  // Both stay mounted because the flag can flip once flags load (e.g. after
  // login, when org flags are fetched). Neither syncs until flags have loaded.
  const legacyPlaces = useLegacyPlaces({
    ...props,
    enabled: !serverSourceOfTruth && !flagsLoading,
  });

  const apiPlaces = useApiPlaces({ ...props, enabled: serverSourceOfTruth });

  if (flagsLoading) {
    return { ...legacyPlaces, loading: true };
  }

  return serverSourceOfTruth ? apiPlaces : legacyPlaces;
};
